<script setup>
import { computed, ref } from 'vue';
import Icon from 'next/icon/Icon.vue';
import { useSnakeCase } from 'dashboard/composables/useTransformKeys';
import { useMessageContext } from '../provider.js';
import GalleryView from 'dashboard/components/widgets/conversation/components/GalleryView.vue';

const props = defineProps({
  attachment: {
    type: Object,
    required: true,
  },
  // Cung luat voi anh: di mot minh thi giu ti le that, di theo bo thi cat vuong
  // cho vao luoi. Xem AttachmentChips.vue.
  single: {
    type: Boolean,
    default: false,
  },
  remaining: {
    type: Number,
    default: 0,
  },
});

const showGallery = ref(false);
const hasError = ref(false);

const remainingLabel = computed(() => `+${props.remaining}`);

const { filteredCurrentChatAttachments } = useMessageContext();

const aspectRatio = computed(() => {
  const { width, height } = props.attachment;
  return width && height ? `${width} / ${height}` : '4 / 3';
});

// GalleryView bao loi nguoc len; truoc day no goi mot `onError` khong ai dinh
// nghia nen Vue chi log canh bao roi thoi.
const handleError = () => {
  hasError.value = true;
};
</script>

<template>
  <div
    class="overflow-hidden relative cursor-pointer group bg-n-alpha-1"
    :class="single ? 'w-full' : 'w-full aspect-square'"
    :style="single ? { aspectRatio } : null"
    @click="showGallery = true"
  >
    <div
      v-if="hasError"
      class="flex flex-col gap-1 justify-center items-center text-xs text-center size-full text-n-slate-11"
    >
      <Icon icon="i-lucide-circle-off" class="text-n-slate-11" />
      {{ $t('COMPONENTS.MEDIA.LOADING_FAILED') }}
    </div>
    <template v-else>
      <video
        :src="attachment.dataUrl"
        class="object-cover w-full h-full"
        preload="metadata"
        muted
        playsInline
        @error="handleError"
      />
      <div class="flex absolute inset-0 justify-center items-center">
        <div
          class="overflow-hidden rounded-full transition-transform duration-150 size-9 bg-n-slate-1/60 backdrop-blur-sm shadow-[0_5px_15px_rgba(0,0,0,0.4)] group-hover:scale-110"
        >
          <Icon
            icon="i-teenyicons-play-small-solid"
            class="size-9 text-n-slate-12/80 backdrop-blur"
          />
        </div>
      </div>
      <div
        v-if="remaining > 0"
        class="flex absolute inset-0 justify-center items-center text-xl font-semibold text-white bg-n-slate-12/60"
      >
        {{ remainingLabel }}
      </div>
    </template>
  </div>
  <GalleryView
    v-if="showGallery"
    v-model:show="showGallery"
    :attachment="useSnakeCase(attachment)"
    :all-attachments="filteredCurrentChatAttachments"
    @error="handleError"
    @close="() => (showGallery = false)"
  />
</template>
